"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=RequestDocumentQuickPulse.js.map